import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "Federal Employee Mental Health Benefits | Neuro Wellness TMS Centers of America",
  description:
    "Federal employees: understand your mental health benefits under FEHB and PSHB, including what treatment options may be available for depression.",
  canonical: "/federal-employee-mental-health-benefits",
  keywords:
    "federal employee mental health benefits, FEHB mental health, federal employee depression benefits, PSHB mental health",
};

const relatedLinks = [
  { title: "Federal Employee Hub", href: "/federal-employee-mental-health" },
  { title: "FEHB TMS Coverage", href: "/fehb-tms-coverage" },
  { title: "Federal Employee TMS", href: "/federal-employee-tms" },
  {
    title: "Federal Employee Insurance Verification",
    href: "/federal-employee-insurance-verification",
  },
];

export default function FederalEmployeeMentalHealthBenefits() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Federal Employee Benefits"
      title="Federal Employee Mental Health Benefits"
      subtitle="Understanding what your FEHB or PSHB plan may cover for mental health treatment, including TMS, SAINT, and depression care."
    >
      <DecisionSection heading="Mental health coverage under FEHB">
        <p>
          All FEHB plans include mental health and substance use disorder
          benefits as essential health benefits. This means your plan may cover
          services like psychotherapy, psychiatric evaluation, medication
          management, and — when medical necessity criteria are met — advanced
          treatments like TMS.
        </p>
        <p>
          The specific services covered, and the amount your plan pays, depend
          on which carrier and plan you're enrolled in. FEP Blue, Aetna, GEHA,
          MHBP, and other FEHB carriers each have their own networks,
          formularies, and coverage policies.
        </p>
      </DecisionSection>

      <DecisionSection heading="What may be covered">
        <DecisionList
          items={[
            "Psychiatric evaluation and consultation",
            "Psychotherapy and counseling sessions",
            "Medication management and psychiatric follow-up",
            "TMS therapy when medical necessity criteria are met",
            "Accelerated TMS protocols (plan and policy dependent)",
            "SPRAVATO (esketamine) for treatment-resistant depression",
          ]}
        />
        <p>
          Coverage for advanced treatments like TMS and SAINT depends on your
          specific plan's medical policy, your diagnosis, and your treatment
          history. Prior authorization is typically required.
        </p>
      </DecisionSection>

      <DecisionSection heading="Parity protections">
        <p>
          Under the Mental Health Parity and Addiction Equity Act, FEHB plans
          must treat mental health and substance use disorder benefits on par
          with medical and surgical benefits. This means copays, deductibles,
          and treatment limits for mental health care should be no more
          restrictive than those for other medical care.
        </p>
      </DecisionSection>

      <DecisionSection heading="Your next step">
        <p>
          The best way to understand what your plan covers is to verify your
          benefits. Our team can review your FEHB or PSHB plan, explain what
          treatment options may be available, and handle the authorization
          process.
        </p>
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link
            to="/federal-employee-insurance-verification"
            className="text-accent hover:underline"
          >
            start the verification process
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
